import { Baggage, Measurement } from '../../../../BaggageService/types';

const BAGGAGE_AMOUNT_PATTERN = /^\s*(\d+(?:[.,]\d+)?)/;

const parseBaggageAmount = (baggageWeight: string): number | null => {
	const match = baggageWeight.split('x')[0].match(BAGGAGE_AMOUNT_PATTERN);

	return match ? Number(match[1].replace(',', '.')) : null;
};

/**
 * WEBSKY-8732: PC-концепт — включенный в тариф багаж без веса (null / 0kg / 0кг / 0.0) трактуется как одно место.
 */
export const isPieceConceptBaggageWeight = (baggageWeight?: string | null): boolean => {
	if (!baggageWeight) {
		return true;
	}

	return parseBaggageAmount(baggageWeight) === 0;
};

export const getIncludedBaggageWeightValue = (baggageWeight?: string | null): Baggage['value'] => {
	if (isPieceConceptBaggageWeight(baggageWeight)) {
		return { amount: 1, measurement: Measurement.Pieces };
	}

	return {
		amount: parseBaggageAmount(baggageWeight ?? '') ?? 0,
		measurement: Measurement.Kilograms
	};
};
